import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import { MyParadiseOrderSummary } from "@app/components/myParadise/MyParadiseOrderSummary/MyParadiseOrderSummary"
import Page from "@app/components/pageTypes/Page/Page"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetOrderHistory } from "@app/store/service/connectorService"

export default function AppOrderHistoryPage() {
	const { data: orderHistory } = useGetOrderHistory()
	const { data: strings } = useGetStrings()
	const { orderHistoryModalTitle } = strings ? strings : {}

	if (orderHistory) {
		let orders = Array.from(orderHistory)
		return (
			<Page>
				<ContentHeader>{orderHistoryModalTitle}</ContentHeader>
				<ContentBody>
					{orders.map((e, i) => (
						<MyParadiseOrderSummary key={i} webToken={e.webToken} orderNumber={e.orderCode} date={e.date} totalAmount={e.totalAmount} />
					))}
				</ContentBody>
			</Page>
		)
	}
}
